import React from 'react';

import { AttentionMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Loader } from '@eika/loader';
import { Modal } from '@eika/modal';

import { useCard } from '@/react-query/hooks/query/use-card';

import { useConfigLink, useNavigate } from '@domain/app';
import useText from '@hooks/use-text';
import { navigateToCardDetails } from '@utils/url/get-card-details-url-utils';

export const AndroidWalletLowAssuranceWarning = () => {
    const { googleWalletHighAssuranceMissingText, googleWalletStepUpProceed, googleWalletHighAssuranceMissingTitle } =
        useText();

    const currentCardQuery = useCard();
    const link = useConfigLink('stepUpAuthLink', { url: '/nettbank/innstillinger/identifiser-deg' });
    const navigate = useNavigate();

    if (!currentCardQuery.isSuccess) {
        return <Loader />;
    }

    return (
        <Modal
            title={googleWalletHighAssuranceMissingTitle}
            open
            setOpen={() => currentCardQuery && navigateToCardDetails(navigate)(currentCardQuery.data)}
        >
            <AttentionMessage
                type="warning"
                id="google-pay-low-assurance"
                text={googleWalletHighAssuranceMissingText}
                icon={IconTypes.INFO_24}
                clickableItem={<Link href={link.url}>{googleWalletStepUpProceed}</Link>}
            />
        </Modal>
    );
};
